export default __webpack_public_path__ + "static/petals-8ff17babf5b72b516d15c7f267b86de8.png";